import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import styles from "./FloatingActionButton.module.css"

export default function FloatingButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`${styles.fab} ${visible ? styles.visible : ""}`}
    >
      <ChevronUp size={24} />
    </button>
  );
}